import { render, staticRenderFns } from "./SendToUserModal.vue?vue&type=template&id=5a54157f&scoped=true&"
import script from "./SendToUserModal.vue?vue&type=script&lang=js&"
export * from "./SendToUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a54157f",
  null
  
)

export default component.exports